import { render, staticRenderFns } from "./AgendaViewPage.vue?vue&type=template&id=93e7641c"
import script from "./AgendaViewPage.vue?vue&type=script&lang=js"
export * from "./AgendaViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports